/**
 * After any successful add to cart, go to the cart page instead of opening
 * the cart drawer.
 *
 * Horizon's product form (buy buttons, quick add, the sticky add-to-cart bar
 * and both personalization wizards all submit through it) reports the result
 * as a bubbling `cart:update` event whose detail.data.source is
 * 'product-form-component', with didError set when Shopify refused the add.
 * The cart drawer and cart page fire `cart:update` too, for quantity changes,
 * with a different source, so those are left alone.
 *
 * Listening on window in the capture phase runs this before the theme's own
 * listeners on document. On success it stops the event there, so the drawer
 * never starts opening behind the page change. A refused add passes through
 * untouched, so the theme still shows its error next to the button.
 *
 * Just before the page changes it fires `trackstar:before-cart-redirect` on
 * window with a detail of { hold: 0 }. A listener can raise detail.hold (ms)
 * to keep the shopper here a moment longer. The personalization wizards use
 * it to show their confetti: this script stops the cart:update event, so they
 * never hear about a successful add any other way. The hold is capped, so no
 * listener can strand a shopper on the product page.
 */
(function () {
  if (window.__tsCartRedirect) return;
  window.__tsCartRedirect = true;

  // Longest a before-cart-redirect listener may delay the page change.
  var MAX_HOLD_MS = 1500;

  window.addEventListener('cart:update', function (event) {
    var data = event.detail && event.detail.data;
    if (!data || data.source !== 'product-form-component' || data.didError) return;

    event.stopImmediatePropagation();
    var routes = window.Theme && window.Theme.routes;
    var cartUrl = (routes && routes.cart_url) || '/cart';

    var detail = { hold: 0 };
    try {
      window.dispatchEvent(new CustomEvent('trackstar:before-cart-redirect', { detail: detail }));
    } catch (e) {
      // A listener failing must never cost the redirect.
    }
    var hold = Math.min(Math.max(Number(detail.hold) || 0, 0), MAX_HOLD_MS);
    if (hold) setTimeout(function () { window.location.href = cartUrl; }, hold);
    else window.location.href = cartUrl;
  }, true);
})();
